import { useState } from 'react'

import { Disclosure, DisclosurePanel } from '@headlessui/react'
import { IconGraphQl } from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { GraphQlSubNav } from './GraphQlSubNav'
import { calculateNestedMargin } from '~/components/ConsumerSideNavigation/helpers'
import { SideNavItem } from '~/components/ConsumerSideNavigation/SideNavItem'
import { ApiTocItem } from '~/types/content'

export const GraphQlNavItem = ({
  item,
  isActive,
  level,
  openIds,
  onClick,
  isMobile,
}: {
  item: ApiTocItem,
  isActive: boolean,
  level: number,
  openIds: string[],
  onClick?: (e: any) => void,
  isMobile?: boolean,
}) => {
  const { t } = useTranslation()
  const location = useLocation()

  const [selectedGraphQlComponentItem, setSelectedGraphQlComponentItem] = useState<string | null>(null)

  return (
    <Disclosure aria-label={t('consumer.sideNavigation.apiNavItem.ariaLabel')} as="div" defaultOpen={openIds.indexOf(item.tableOfContentsId) >= 0} key={`${item.path}-${openIds.join('-')}`}>
      {({ open }) => (
        <>
          <SideNavItem
            path={`${item.path}${location.search}`}
            title={item.title}
            icon={<IconGraphQl />}
            isActive={isActive}
            isExpandable={item.graphqlComponents && item.graphqlComponents.length > 0}
            level={level}
            open={open}
            isApi={true}
            selectedOperationOrSchema={selectedGraphQlComponentItem}
            setSelectedOperationOrSchema={setSelectedGraphQlComponentItem}
            onClick={onClick}
            isMobile={isMobile}
            isGraphQl={true}
          />
          <DisclosurePanel style={{ paddingLeft: calculateNestedMargin(level, isMobile) }} className={clsx(level > 0 && 'pr-3')}>
            <div className={clsx(isActive ? 'bg-neutral-10 dark:bg-neutral-95 rounded-b' : 'bg-white dark:bg-neutral-98')}>
              {item.graphqlComponents && item.graphqlComponents.length > 0 ? item.graphqlComponents.map(graphQlComponent => (
                <GraphQlSubNav
                  key={graphQlComponent.title}
                  graphQlComponent={graphQlComponent.title}
                  graphQlComponentItems={graphQlComponent.items}
                  active={isActive}
                  parentPath={`${item.path}${location.search}`}
                  level={level}
                  selectedGraphQlComponentItem={selectedGraphQlComponentItem}
                  setSelectedGraphQlComponentItem={setSelectedGraphQlComponentItem}
                  onClick={onClick}
                />
              )) : null}
              <div className="separator h-1.5" />
            </div>
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  )
}